/** Calendar helpers shared by the bed board, the High Risk board and the
 *  Discharge Plan screen. The census folders, the <input type="date"> values
 *  and every "today" comparison are Eastern calendar days; a UTC day flips
 *  the answer for several hours every evening. */

export const ISO_DATE_RE = /^\d{4}-\d{2}-\d{2}$/;

/** Today as YYYY-MM-DD in the facilities' own timezone. */
export function easternToday(): string {
  // 'en-CA' formats as YYYY-MM-DD, which is what the folders and the <input
  // type="date"> value both use.
  return new Date().toLocaleDateString('en-CA', { timeZone: 'America/New_York' });
}
